<template>
  <h1>庫存</h1>
</template>

<script>
export default {}
</script>

<style></style>
